export const OPENING_STATUSES = ['OPEN', 'CLOSED'] as const;
export type OpeningStatus = (typeof OPENING_STATUSES)[number];

export const CANDIDATE_STAGES = ['APPLIED', 'SCREENING', 'INTERVIEW', 'OFFER', 'HIRED', 'REJECTED'] as const;
export type CandidateStage = (typeof CANDIDATE_STAGES)[number];

/** Stages a candidate is still being considered in; hiring and rejecting leave them. */
export const CANDIDATE_OPEN_STAGES = ['APPLIED', 'SCREENING', 'INTERVIEW', 'OFFER'] as const satisfies readonly CandidateStage[];
export type CandidateOpenStage = (typeof CANDIDATE_OPEN_STAGES)[number];

export function isOpenCandidateStage(stage: string): stage is CandidateOpenStage {
  return (CANDIDATE_OPEN_STAGES as readonly string[]).includes(stage);
}

/** Stages a candidate is moved to by hand; HIRED is reached only through hiring. */
export const CANDIDATE_MOVE_STAGES = ['APPLIED', 'SCREENING', 'INTERVIEW', 'OFFER', 'REJECTED'] as const satisfies readonly CandidateStage[];
export type CandidateMoveStage = (typeof CANDIDATE_MOVE_STAGES)[number];

export const CANDIDATE_EVENT_KINDS = ['APPLIED', 'STAGE_CHANGED', 'NOTE', 'RATING', 'HIRED'] as const;
export type CandidateEventKind = (typeof CANDIDATE_EVENT_KINDS)[number];

export const CANDIDATE_FILE_KINDS = ['CV'] as const;
export type CandidateFileKind = (typeof CANDIDATE_FILE_KINDS)[number];

export const CV_MAX_BYTES = 5 * 1024 * 1024;

/** The file name the demo seed gives its one stored CV; `seedDemoCandidateCvs` writes the PDF behind it. */
export const DEMO_CV_FILE = 'demo-cv.pdf';

export const DEFAULT_CANDIDATE_RETENTION_MONTHS = 6;
